import { useMemo, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { FormTitleBox } from '../../common/components';
import { useLegalEntities } from '../../hooks/useLegalEntities';
import AdjustmentsTab from './components/AdjustmentsTab';
import DashboardTab from './components/DashboardTab';
import InvoicesTab from './components/InvoicesTab';
import ProvidersTab from './components/ProvidersTab';
import ReportsTab from './components/ReportsTab';

const SupplierLedger = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { data: legalEntities = [] } = useLegalEntities();
  const providers = useMemo(
    () => legalEntities.filter((entity) => entity.is_provider !== false && entity.is_active !== false),
    [legalEntities],
  );
  const providerMap = useMemo(() => {
    const map = {};
    legalEntities.forEach((entity) => {
      map[entity.uuid] = entity.legal_business_name || entity.company || entity.cuit || entity.uuid;
    });
    return map;
  }, [legalEntities]);
  const tabs = useMemo(() => [
    {
      label: 'Cargar facturas',
      content: <InvoicesTab providers={providers} providerMap={providerMap} />,
    },
    {
      label: 'Cuentas corrientes',
      content: <ProvidersTab />,
    },
    {
      label: 'Ajustes y saldos',
      content: <AdjustmentsTab providers={providers} providerMap={providerMap} />,
    },
    {
      label: 'Informes',
      content: <ReportsTab />,
    },
    {
      label: 'Tableros',
      content: <DashboardTab />,
    },
  ], [providerMap, providers]);

  return (
    <Box>
      <FormTitleBox title="Finanzas | Cuentas corrientes proveedores" />
      <Box sx={{ backgroundColor: 'background.paper', borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={(_, value) => setActiveTab(value)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 44,
            '& .MuiTab-root': {
              minHeight: 44,
              fontSize: 13,
              fontWeight: 600,
            },
          }}
        >
          {tabs.map((tab) => (
            <Tab key={tab.label} label={tab.label} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ backgroundColor: 'background.paper' }}>
        {tabs[activeTab]?.content}
      </Box>
    </Box>
  );
};

export default SupplierLedger;
